/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homeherosubline2Inputs */



/**
* | output |
* | --- |
* | "By DMUN e.V." |
*
* @param {Homeherosubline2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const homeherosubline2 = /** @type {((inputs?: Homeherosubline2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homeherosubline2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("By DMUN e.V.")
	return /** @type {LocalizedString} */ ("Von DMUN e.V.")
});
export { homeherosubline2 as "homeHeroSubline" }